import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import {
    CollectedItem,
    CollectedItemPatchRequest,
    CollectedItemUpsertRequest,
    CollectedItemsListResponse,
    ProductRequirementGroup,
} from './data-collection.dto';

export const admiDataCollectionService = {
    async getProductRequirementGroups(productId: string): Promise<ProductRequirementGroup[]> {
        const response = await httpClient2.get<ProductRequirementGroup[]>(
            `/v1/products/${productId}/requirement-groups`,
        );
        return response.data;
    },

    /**
     * The full requirement catalog — every configured group with all its
     * fields, independent of product assignments (GEN-653). Fields come with
     * the neutral `dataCriticality: 'optional'`; per-product criticality is
     * only on `getProductRequirementGroups`.
     */
    async getRequirementGroupsCatalog(): Promise<ProductRequirementGroup[]> {
        const response = await httpClient2.get<ProductRequirementGroup[]>('/v1/requirement-groups');
        return response.data;
    },

    async listCollectedItems(assetId: string): Promise<CollectedItemsListResponse> {
        const response = await httpClient2.get<CollectedItemsListResponse>(
            `/v1/real-estate-assets/${assetId}/collected-items`,
        );
        return response.data;
    },

    /**
     * Upsert (create-or-update) keyed on (assetId, requirementCode). Used by the
     * data-collection UI: the FE doesn't know the upstream-minted `code` on first
     * save, so it calls upsert instead of patch.
     */
    async upsertCollectedItem(assetId: string, request: CollectedItemUpsertRequest): Promise<CollectedItem> {
        const response = await httpClient2.post<CollectedItem>(
            `/v1/real-estate-assets/${assetId}/collected-items`,
            request,
        );
        return response.data;
    },

    async patchCollectedItem(
        assetId: string,
        code: string,
        request: CollectedItemPatchRequest,
    ): Promise<CollectedItem> {
        const response = await httpClient2.patch<CollectedItem>(
            `/v1/real-estate-assets/${assetId}/collected-items/${code}`,
            request,
        );
        return response.data;
    },
};
